import {ajaxRequest} from "./api.js";
import {_utils} from "../utils/_utils.js";

export const apiUtils = {
    async getContent(queryParams, ajaxName) {
        let response = await ajaxRequest(queryParams, ajaxName);
        if(response !== null && response.status === 200){
            const data = response.data;
            if(_utils.isNonEmptyObject(data)){
                window.dispatchEvent(new Event('ajaxSuccess'));
                return data;
            }
            return null;
        }
        return null;
    },
    replaceContent(wrapper = null, html = null){
        if(wrapper !== null && html !== null){
            wrapper.innerHTML = html;
        }
    },
    addContent(wrapper = null, html = null, selector = 'li'){
        if(wrapper !== null && html !== null){
            new DOMParser().parseFromString(html, "text/html").querySelectorAll(`${selector}`).forEach(el => {
                wrapper.append(el);
            });
        }
    }
}
export const beforeSubmit = (section, callback) => {
    window.dispatchEvent(new Event('ajaxBeforeSubmit'));
    section?.classList.add('loading');
    if (typeof callback === 'function') {
        callback();
    }
}
export const afterSubmit = (section, callback) => {
    window.dispatchEvent(new Event('ajaxAfterSubmit'));
    section?.classList.remove('loading');
    if (typeof callback === 'function') {
        callback();
    }
}